import { supabase } from "@/services/supabase";
import { SUPABASE_PUBLISHABLE_KEY, SUPABASE_URL } from "@/config/publicConfig";

export interface RedeemSuccess {
  status: "ok" | "already_redeemed";
  vip_days_added: number;
  wallet_days_after: number;
  badge: "supporter" | "founder" | "patron" | null;
  batch_name: string | null;
}

/** 后端错误码（见 docs/contracts/backend_rpc.md「redeem-code」） */
export class RedeemError extends Error {
  constructor(public code: string) {
    super(code);
  }
}

export async function redeemCode(code: string): Promise<RedeemSuccess> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (!token) throw new RedeemError("UNAUTHORIZED");

  const res = await fetch(`${SUPABASE_URL}/functions/v1/redeem-code`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: SUPABASE_PUBLISHABLE_KEY,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ code }),
  });

  let body: { error?: string } & Partial<RedeemSuccess> = {};
  try {
    body = await res.json();
  } catch {
    /* 非 JSON 响应按通用错误处理 */
  }
  if (!res.ok || body.error) throw new RedeemError(body.error ?? "DEFAULT");
  return body as RedeemSuccess;
}
